import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { formatDataTestId, renderSanitizedHtml } from '@whitbread-eos/utils';
import { format } from 'date-fns';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StaticFooterComponent() {
  var baseDataTestId = 'Footer';
  var footerWrapperStyles = () => {
    return {
      w: 'full',
      borderTop: '1px solid var(--chakra-colors-lightGrey1)',
      pt: {
        mobile: '0',
        md: 'lg',
        lg: 'lg',
        xl: '3xl'
      },
      px: {
        mobile: 'md',
        md: 'md',
        lg: 'xl',
        xl: '5xl'
      },
      pb: {
        lg: 'lg',
        xl: '3xl'
      }
    };
  };
  var copyrightData = "&copy; ".concat(format(new Date(), 'yyyy'), " Premier Inn");
  return _jsx(Box, _objectSpread(_objectSpread({
    maxW: "var(--chakra-space-breakpoint-xl)"
  }, footerWrapperStyles()), {}, {
    "data-testid": formatDataTestId(baseDataTestId, 'Wrapper-Error'),
    children: _jsx(Flex, _objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'CopyrightSection')
    }, copyrightSectionStyles), {}, {
      children: _jsx(Text, _objectSpread(_objectSpread({}, copyrightStyles), {}, {
        className: "formatLinks",
        children: renderSanitizedHtml(copyrightData)
      }))
    }))
  }));
}
var copyrightStyles = {
  fontSize: 'sm',
  fontWeight: 'normal',
  lineHeight: 1,
  color: 'darkGrey1'
};
var copyrightSectionStyles = {
  justifyContent: 'space-between',
  alignItems: 'center',
  w: 'full'
};